// initiation for chord chart
// import opts from './_opts';

export default function (txt) {

    d3.select('#js-chart-note')
        .text(txt);
}